class SafeStorage implements Storage {
    private storage: Storage;

    constructor(storage: Storage) {
        this.storage = storage;
    }

    get length() {
        try {
            return this.storage.length;
        } catch {
            return 0;
        }
    }

    clear() {
        try {
            this.storage.clear();
        } catch {}
    }

    getItem(key: string): string | null {
        try {
            return this.storage.getItem(key);
        } catch {
            return null;
        }
    }

    key(index: number): string | null {
        try {
            return this.storage.key(index);
        } catch {
            return null;
        }
    }

    removeItem(key: string) {
        try {
            this.storage.removeItem(key);
        } catch {}
    }

    setItem(key: string, value: string) {
        try {
            this.storage.setItem(key, value);
        } catch {}
    }
}

const MOCKED_FN_NULL = () => null;
const MOCKED_FN_VOID = () => {};

const MOCK_STORAGE: Storage = {
    length: 0,
    key: MOCKED_FN_NULL,
    clear: MOCKED_FN_VOID,
    setItem: MOCKED_FN_VOID,
    getItem: MOCKED_FN_NULL,
    removeItem: MOCKED_FN_VOID,
};

let local: Storage = MOCK_STORAGE;
let session: Storage = MOCK_STORAGE;

if (!__IS_SERVER__) {
    try {
        local = new SafeStorage(localStorage);
        session = new SafeStorage(sessionStorage);
    } catch {}
}

export {local, session};
